import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { PaginatedResponse, Response } from '../genericInterface';
import { IPromotion, IPromotionVendors } from './interface';

export const promotionApi = createApi({
  reducerPath: 'promotionApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['promotions'],
  endpoints: (builder) => ({
    getAllPromotions: builder.query<
      PaginatedResponse<IPromotion>,
      string | void
    >({
      query: (queryParams) => ({
        url: `/promotion/fetch-many`,
        method: 'GET'
      }),
      providesTags: ['promotions']
    }),
    addPromotion: builder.mutation<Response<IPromotion>, FormData>({
      query: (payload) => ({
        url: '/promotion/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: [`promotions`]
    }),
    fetchVendors: builder.query<
      PaginatedResponse<IPromotionVendors>,
      string | void
    >({
      query: (query) => ({
        url: `/promotion/fetch-vendors?${query}`,
        method: 'GET'
      })
    }),
    editPromotions: builder.mutation<
      Response<IPromotion>,
      { body: FormData; id: string }
    >({
      query: (payload) => ({
        url: `/promotion/edit/${payload.id}`,
        method: 'PATCH',
        body: payload.body
      }),
      invalidatesTags: ['promotions']
    }),
    deletePromotions: builder.mutation<Response<null>, string>({
      query: (payload) => ({
        url: `/promotion/delete/${payload}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['promotions']
    }),
    getPromotionById: builder.query<Response<IPromotion>, string>({
      query: (id) => ({
        url: `/promotion/fetch-one/${id}`,
        method: 'GET'
      }),
      providesTags: (_res, _err, arg) => [{ type: 'promotions', id: arg }]
    })
  })
});
export const {
  useAddPromotionMutation,
  useFetchVendorsQuery,
  useGetAllPromotionsQuery,
  useEditPromotionsMutation,
  useDeletePromotionsMutation,
  useGetPromotionByIdQuery
} = promotionApi;
